import React, { useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-xl z-50 border-b border-gray-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_d715e127-673d-402c-8a56-d9b15a0f1ccd/artifacts/si2vae0p_IMG_20260101_084232.jpg" 
              alt="Structure Savers Logo"
              className="h-12 w-auto object-contain"
            />
            <div className="hidden lg:block">
              <p className="text-xs text-gray-600 font-medium tracking-wide">
                Waterproofing Specialist and Construction Expert
              </p>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-black transition-colors font-medium text-sm tracking-wide">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-black transition-colors font-medium text-sm tracking-wide">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-black transition-colors font-medium text-sm tracking-wide">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-black transition-colors font-medium text-sm tracking-wide">
              Contact
            </button>
            <Button onClick={() => scrollToSection('quote')} className="bg-black hover:bg-gray-800 text-white rounded-full px-6 py-2 font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
              <Phone className="w-4 h-4 mr-2" />
              Get Quote
            </Button>
          </nav>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-black p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <nav className="flex flex-col px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="text-left text-gray-700 hover:text-black hover:bg-gray-50 transition-colors font-medium py-3 px-4 rounded-lg">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-left text-gray-700 hover:text-black hover:bg-gray-50 transition-colors font-medium py-3 px-4 rounded-lg">
              Services
            </button>
            <button onClick={() => scrollToSection('about')} className="text-left text-gray-700 hover:text-black hover:bg-gray-50 transition-colors font-medium py-3 px-4 rounded-lg">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-black hover:bg-gray-50 transition-colors font-medium py-3 px-4 rounded-lg">
              Contact
            </button>
            <Button onClick={() => scrollToSection('quote')} className="bg-black hover:bg-gray-800 text-white w-full rounded-full py-3 font-semibold shadow-lg">
              <Phone className="w-4 h-4 mr-2" />
              Get Quote
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;